import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTreeModule } from '@angular/material/tree';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatStepperModule } from '@angular/material/stepper';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { FullCalendarModule } from '@fullcalendar/angular';
import {CdkAccordionModule} from '@angular/cdk/accordion';
import { InputFileUploadComponent } from './components/input-file-upload/input-file-upload.component';
import { ModalPdfViewerComponent } from './components/modal-pdf-viewer/modal-pdf-viewer.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDateFormats, MAT_DATE_FORMATS } from '@angular/material/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { DialogYesNoComponent } from './components/dialog-yes-no/dialog-yes-no.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { BlockingProgressDialogComponent } from './components/blocking-progress-dialog/blocking-progress-dialog.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDividerModule } from '@angular/material/divider';


export const BRAZILIAN_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


@NgModule({
  declarations: [
    InputFileUploadComponent,
    ModalPdfViewerComponent,
    DialogYesNoComponent,
    ConfirmDialogComponent,
    BlockingProgressDialogComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskDirective,
    NgxMaskPipe,
    MatPaginatorModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatTreeModule,
    MatCardModule,
    MatTableModule,
    MatStepperModule,
    MatIconModule,
    MatButtonModule,
    MatOptionModule,
    MatSelectModule,
    MatProgressBarModule,
    MatMenuModule,
    MatTabsModule,
    FlexLayoutModule,
    MatDialogModule,
    MatTooltipModule,
    ClipboardModule,
    PdfViewerModule,
    MatAutocompleteModule,
    FullCalendarModule,
    NgxDropzoneModule,
    MatDatepickerModule,
    MatNativeDateModule,
    DragDropModule,
    CdkAccordionModule,
    MatExpansionModule,
    NgScrollbarModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatDividerModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskDirective,
    NgxMaskPipe,
    InputFileUploadComponent,
    MatPaginatorModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatTreeModule,
    MatCardModule,
    MatTableModule,
    MatStepperModule,
    MatIconModule,
    MatButtonModule,
    MatOptionModule,
    MatSelectModule,
    MatProgressBarModule,
    MatMenuModule,
    MatTabsModule,
    FlexLayoutModule,
    MatDialogModule,
    MatTooltipModule,
    ClipboardModule,
    MatChipsModule,
    MatAutocompleteModule,
    FullCalendarModule,
    NgxDropzoneModule,
    MatDatepickerModule,
    MatNativeDateModule,
    DragDropModule,
    CdkAccordionModule,
    MatExpansionModule,
    NgScrollbarModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatDividerModule,
    ConfirmDialogComponent,
    BlockingProgressDialogComponent,
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: MAT_DATE_FORMATS, useValue: BRAZILIAN_DATE_FORMATS },
  ]
})
export class SharedModule {}
